import { QuestInstance } from "@joonapp/web-shared/dist/types/quests"
import dayjs, { Dayjs } from "dayjs"
import { create } from "zustand"

export enum QuestModalView {
  ADD,
  EDIT,
  DETAILS,
}

interface QuestModalStore {
  isOpen: boolean
  onOpen: (questGroup?: QuestInstance[]) => void
  onClose: () => void

  view: QuestModalView
  setView: (view: QuestModalView) => void

  questGroup: QuestInstance[] | null
  title: string
  description: string
  selectedUserIds: number[]
  time: string | null
  date: Dayjs | null

  setTitle: (title: string) => void
  setDescription: (description: string) => void
  setSelectedUserIds: (selectedUserIds: number[]) => void
  toggleSelectedUser: (userId: number) => void
  setTime: (time: string | null) => void
  setDate: (date: Dayjs | null) => void
  setQuestGroup: (questGroup: QuestInstance[] | null) => void

  error: string | null
  setError: (error: string) => void

  attachment: File | null | undefined
  setAttachment: (attachment: File | null | undefined) => void
}

const initialState = {
  isOpen: false,
  questGroup: null,
  selectedUserIds: [],
  title: "",
  description: "",
  time: dayjs().format("hh:mm A"),
  date: dayjs().add(1, "day"),
  view: QuestModalView.DETAILS,
  error: null,
  attachment: undefined,
}

export const useQuestModalStore = create<QuestModalStore>((set) => ({
  ...initialState,
  onOpen: (questGroup) => {
    set({ isOpen: true, questGroup })
    if (questGroup) {
      const questInfo = questGroup[0]

      set({
        title: questInfo.series.title,
        description: questInfo.series.description || "",
        selectedUserIds: questGroup.map((quest) => quest.user_id),
        time: questInfo.series.reminder_time,
        date: questInfo.date ? dayjs(questInfo.date) : null,
      })
    } else {
      set({ view: QuestModalView.ADD })
    }
  },
  onClose: () => set(initialState),
  setView: (view) => set({ view }),

  setTitle: (title) => set({ title }),
  setDescription: (description) => set({ description }),
  setSelectedUserIds: (selectedUserIds) => set({ selectedUserIds }),
  toggleSelectedUser: (userId) =>
    set((state) => ({
      selectedUserIds: state.selectedUserIds.includes(userId)
        ? state.selectedUserIds.filter((id) => id !== userId)
        : [...state.selectedUserIds, userId],
    })),
  setTime: (time) => set({ time }),
  setDate: (date) => set({ date }),
  setQuestGroup: (questGroup) => set({ questGroup }),
  setError: (error) => set({ error }),
  setAttachment: (attachment) => set({ attachment }),
}))
